export default {
    path: '/unauthorized',
    name: 'Unauthorized',
    meta: {
        title: 'Unauthorized',
        documentTitle: 'Unauthorized',
        requiresAuth: true,
        shouldPersistBetweenLogins: false,
    },
    component: () => import( /* webpackChunkName: "Unauthorized" */ '@/views/Unauthorized' ),
};
